export const ADD_SINTOMA = "ADD_SINTOMA";
export const DELETE_SINTOMA = "DELETE_SINTOMA";
export const RESTART_SINTOMA = "RESTART_SINTOMA";
export const UPDATE_SINTOMA = "UPDATE_SINTOMA";
